export { default } from "@/ErrorBoundary"
